import { createAction, handleActions } from 'redux-actions';

const SET_INSURANCE_SAVE_ERROR = 'SET_INSURANCE_SAVE_ERROR';

export const setInsuranceSaveError = createAction(SET_INSURANCE_SAVE_ERROR);

export const reducer = handleActions(
  new Map([
    [
      setInsuranceSaveError,
      (state, action) => action.payload
    ],
  ]),
  null
); 